@import 'styles/variables';
@import 'styles/mixins.scss';
@import 'styles/blaze/mixins';

.submitButton {
  @include for-tablet-portrait-max {
    margin: 24px auto;
  }
  &:hover {
    color: var(--light-100);
    background: var(--dark-60);
  }
}

.buttonContainer {
  width: 100%;
  display: flex;
  justify-content: center;

  .buttonContent {
    display: flex;
    justify-content: center;
    gap: 8px;
  }
}

.gapForm {
  margin-top: 16px;
  margin-bottom: 48px;
}

.gapSubtitle {
  @include for-phone-only {
    max-width: 225px;
    margin: auto;
  }
}

.gapHeader {
  text-align: center;
  @include for-small-desktop-up {
    padding-bottom: 30px;
  }
}

.leftContent {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 110px;

  @include for-tablet-portrait-max {
    margin-top: 30px;
  }
}

.warning {
  color: red;
  display: inline;
  margin-left: 4px;
}

.leftArrow {
  margin-left: 6px;
}

.form {
  display: flex;
  width: 90%;
  max-width: 480px;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 50px;

  @include for-tablet-portrait-max {
    padding-top: 24px;
    width: 90%;
    max-width: 500px;
    margin: 0 auto;
  }
}
